import { queryKeys } from '@/hooks/constants';
import { useMutationWithLogging } from '@/hooks/useMutationWithLogging';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import AppService from '@/lib/App';

export interface CreateAdminServicePayload {
  service: {
    prefix: string;
    title: string;
    techFamily: string;
    description: string;
  };
  tenantSeqs: number[];
}

export function useCreateAdminService(options?: { [key: string]: any }) {
  return useMutationWithLogging({
    mutationKey: queryKeys.planner.createAdminService(),
    mutationFn: async (payload: CreateAdminServicePayload) =>
      await AppService.planner.createAdminService(payload),
    ...options,
  });
}

export function useGetServices(
  search?: string,
  options?: { [key: string]: any },
) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.services(search),
    queryFn: () => AppService.planner.getServices(search),
    ...options,
  });
}

export function useGetTechFamilies(
  search?: string,
  options?: { [key: string]: any },
) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.techFamilies(search),
    queryFn: () => AppService.planner.getTechFamilies(search),
    ...options,
  });
}
